import { Component } from '@angular/core';


@Component({
	selector: 'finance-awards-tab-1-part',
	standalone: true,
	templateUrl: './finance-awards-tab-1.part.html',
	styleUrls: [`./finance-awards-tab-1.part.scss`],
})
export class FinanceAwardsTab1Part {
}
